import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import Layout from '@components/common/Layout';
import { showModal } from '@store/actions/commonAction';
import SatDataGrid from '@components/common/satUI/SatDataGrid';
import SatPagination from '@components/common/satUI/SatPagination';
import SatInput from '@components/common/satUI/SatInput';
import SatDatePicker from '@components/common/satUI/SatDatePicker';
import {
    isBeforeDay,
    isAfterDay,
    getToday,
    addDates,
  } from '@common/utils/date';

  import {
    format    
  } from 'date-fns';
import {getCommonCodeDtlList} from '@store/actions/roleAction';
import {changeSearchMenuParam, changeSearchUseParam, getSystemMenuAgg, getSystemUseAgg, getSystemMenuAggExcel, getSystemUseAggExcel} from '@store/actions/statsAction';
import {getHqListByChannel, getAgencyListByHq, getHqAgencyClear} from '@store/actions/commonAction';

import MenuTab from '@components/stats/MenuTab';
import UseTab from '@components/stats/UseTab';

import MenuSearch from '@components/stats/MenuSearch';
import UseSearch from '@components/stats/UseSearch';

import MenuList from '@components/stats/MenuList';
import UseList from '@components/stats/UseList';

const StatsMain = () => {
  let today = new Date();
  let nowDay = today.getDate();
  let nowMonth = today.getMonth();
  let nowYear = today.getFullYear();

  const dispatch = useDispatch();
  const [menuInitial, setMenuInitial] = useState(false);
  const [useInitial, setUseInitial] = useState(false);
  const [activeTab, setActiveTab] = useState('menu');
  const [searchDate, setSearchDate] = useState({
    fromDate: addDates(getToday('yyyyMMdd'), 'month', -2, 'yyyyMMdd'),
    toDate: getToday('yyyyMMdd'),
  });
  const { codeList } = useSelector(state => state.roleReducer);
  const {
    searchMenuInfo,
    searchUseInfo,
    statsMenuList,
    statsMenuTotalCount,
    statsUseList,
    statsUseTotalCount,
  } = useSelector(state => state.statsReducer);
  const { hqList, agencyList } = useSelector(state => state.commonReducer);
  const { error: toastError } = $hooks.useToast();

  useEffect(() => {
    //공통코드 조회(채널)
    dispatch(
      getCommonCodeDtlList({
        cdTyId: 'ORG_CHNL_CD',
        useYn:'Y'
      }),
    );

    //메뉴통계 조회
    dispatch(getSystemMenuAgg(searchMenuInfo));

    //지점별 로그인 현황 조회
    dispatch(getSystemUseAgg(searchUseInfo));
  }, []);

  //날짜
  const handleMenuCalculateDate = useCallback((e, fromTo) => {
    if (fromTo === 'from') {
      setSearchDate(res => ({ ...res, fromDate: e }));
    } else {
      setSearchDate(res => ({ ...res, toDate: e }));
    }

    handleDateSerchDate('menu', e, fromTo);
  }, []);

  const handleUseCalculateDate = useCallback((e, fromTo) => {
    if (fromTo === 'from') {
      setSearchDate(res => ({ ...res, fromDate: e }));
    } else {
      setSearchDate(res => ({ ...res, toDate: e }));
    }

    handleDateSerchDate('use', e, fromTo);
  }, []);

  //날짜로 설계 목록 검색
  const handleDateSerchDate = (type, date, fromTo) => {
    if (type === 'menu') {
      if (fromTo === 'from') {
        dispatch(
          changeSearchMenuParam({
            searchStartDate: date,
          }),
        );
      } else {
        dispatch(
          changeSearchMenuParam({
            searchEndDate: date,
          }),
        );
      }
    } else {
      if (fromTo === 'from') {
        dispatch(
          changeSearchUseParam({
            searchStartDate: date,
          }),
        );
      } else {
        dispatch(
          changeSearchUseParam({
            searchEndDate: date,
          }),
        );
      }
    }
  };

  const getStartWeek = today => {
    const week = ['일', '월', '화', '수', '목', '금', '토'];
    const dayOfWeek = week[new Date(today).getDay()];
    const s_week = week.findIndex(week => week == dayOfWeek);
    return s_week;
  };

  const dayHandler = value => {
    if (value === 'menu') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          searchStartDate: format(new Date(), 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    } else {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          searchStartDate: format(new Date(), 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    }
  };

  const weekHandler = value => {
    const s_week = getStartWeek(today);
    const startWeek = new Date(today.setDate(nowDay - s_week));

    if (value === 'menu') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          searchStartDate: format(startWeek, 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    } else {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          searchStartDate: format(startWeek, 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    }
  };

  const monthHandler = value => {
    const s_month = new Date().getDate();
    const startMonth = new Date(today.setDate(nowDay - s_month + 1));

    if (value === 'menu') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          searchStartDate: format(startMonth, 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    } else {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          searchStartDate: format(startMonth, 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    }
  };

  const yearHandler = value => {
    const s_year = new Date(nowYear, 0, 1);

    if (value === 'menu') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          searchStartDate: format(s_year, 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    } else {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          searchStartDate: format(s_year, 'yyyy.MM.dd'),
          searchEndDate: format(new Date(), 'yyyy.MM.dd'),
        }),
      );
    }
  };

  const handleInputEvent = (value, targetId, type) => {
    if (type === 'menu') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          agentNm: value,
        }),
      );
    } else {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          agentNm: value,
        }),
      );
    }
  };

  const handleAplctnDvcTyCd = type => {
    dispatch(
      changeSearchMenuParam({
        ...searchMenuInfo,
        aplctnDvcTyCd: type,
      }),
    );
  };

  const handleChangeOrgChnlCdMenuSelect = e => {
    if (e.target.id === 'selectChnlId') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          orgChnlCd: e.target.value,
          chnlCd: e.target.value,
          hqCd: '',
          agncCd: '',
        }),
      );

      dispatch(
        getHqListByChannel({
          chnlCd: e.target.value,
        }),
      );

      dispatch(getHqAgencyClear());
    } else if (e.target.id === 'selectHqId') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          hqCd: e.target.value,
          agncCd: '',
        }),
      );

      dispatch(
        getAgencyListByHq({
          chnlCd: searchMenuInfo.orgChnlCd,
          hqCd: e.target.value,
          agncCd: '',
        }),
      );
    } else if (e.target.id === 'selectAgncId') {
      dispatch(
        changeSearchMenuParam({
          ...searchMenuInfo,
          agncCd: e.target.value,
        }),
      );
    }
  };

  const handleChangeOrgChnlCdUseSelect = e => {
    if (e.target.id === 'selectChnlId') {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          orgChnlCd: e.target.value,
          hqCd: '',
          agncCd: '',
        }),
      );

      dispatch(
        getHqListByChannel({
          chnlCd: e.target.value,
          hqCd: '',
          agncCd: '',
        }),
      );

      dispatch(getHqAgencyClear());
    } else if (e.target.id === 'selectHqId') {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          hqCd: e.target.value,
          agncCd: '',
        }),
      );

      dispatch(
        getAgencyListByHq({
          chnlCd: searchUseInfo.orgChnlCd,
          hqCd: e.target.value,
          agncCd: '',
        }),
      );
    } else if (e.target.id === 'selectAgncId') {
      dispatch(
        changeSearchUseParam({
          ...searchUseInfo,
          agncCd: e.target.value,
        }),
      );
    }
  };

  const tabClick = value => {
    setActiveTab(value);
  };

  const menuColumns = [
    {
      title: '채널',
      dataIndex: 'orgChnlCdNm',
      key: 'orgChnlCdNm',
      width: '15%',
    },
    {
      title: '본부',
      dataIndex: 'hqCdNm',
      key: 'hqCdNm',
      width: '15%',
    },
    {
      title: '지점',
      dataIndex: 'agncCdNm',
      key: 'agncCdNm',
      width: '15%',
    },
    {
      title: '사용자',
      dataIndex: 'agentNm',
      key: 'agentNm',
      width: '15%',
    },
    {
      title: '메뉴명',
      dataIndex: 'aggItmIdntfcNm',
      key: 'aggItmIdntfcNm',
      width: '30%',
    },
    {
      title: '사용횟수(뷰수)',
      dataIndex: 'sysUseAggCnt',
      key: 'sysUseAggCnt',
      width: '10%',
    },
  ];

  const menuPageChange = value => {
    setMenuInitial(false);
    dispatch(
      getSystemMenuAgg({
        ...searchMenuInfo,
        targetRow: value * 10 + 1,
      }),
    );
  };

  const useColumns = [
    {
      title: '채널',
      dataIndex: 'orgChnlCdNm',
      key: 'orgChnlCdNm',
      width: '15%',
    },
    {
      title: '본부',
      dataIndex: 'hqCdNm',
      key: 'hqCdNm',
      width: '15%',
    },
    {
      title: '지점',
      dataIndex: 'agncCdNm',
      key: 'agncCdNm',
      width: '15%',
    },
    {
      title: '지점코드',
      dataIndex: 'agncCd',
      key: 'agncCd',
      width: '15%',
    },
    {
      title: '위촉인원수',
      dataIndex: 'agncEmplCo',
      key: 'agncEmplCo',
      width: '13%',
    },
    {
      title: '로그인성공횟수',
      dataIndex: 'sysUseAggCnt',
      key: 'sysUseAggCnt',
      width: '13%',
    },
    {
      title: '사용율(%)',
      dataIndex: 'ratio',
      key: 'ratio',
      width: '13%',
      render: value => Math.round(value * 100) / 100,
    },
  ];

  const usePageChange = value => {
    setUseInitial(false);
    dispatch(
      getSystemUseAgg({
        ...searchUseInfo,
        targetRow: value * 10 + 1,
      }),
    );
  };

  const menuSearch = () => {
    const isValidPeriod = $utils.checkValidPeriod(
      searchMenuInfo.searchStartDate.replaceAll('.', ''),
      searchMenuInfo.searchEndDate.replaceAll('.', ''),
    );

    if (!isValidPeriod) {
      toastError('시작 날짜가 종료 날짜보다 뒤로 설정 될 수는 없습니다.');
      return false;
    }

    setMenuInitial(true);

    dispatch(
      getSystemMenuAgg({
        ...searchMenuInfo,
        targetRow: 1,
      }),
    );
  };

  const useSearch = () => {
    const isValidPeriod = $utils.checkValidPeriod(
      searchUseInfo.searchStartDate.replaceAll('.', ''),
      searchUseInfo.searchEndDate.replaceAll('.', ''),
    );

    if (!isValidPeriod) {
      toastError('시작 날짜가 종료 날짜보다 뒤로 설정 될 수는 없습니다.');
      return false;
    }

    setUseInitial(true);

    dispatch(
      getSystemUseAgg({
        ...searchUseInfo,
        targetRow: 1,
      }),
    );
  };

  const excelDown = type => {
    const today = getToday('yyyyMMddHHmm');

    if (type === 'menu') {
      if (statsMenuList.length > 0) {
        dispatch(
          getSystemMenuAggExcel({
            searchMenuInfo,
            excelFileName: '메뉴별사용통계현황_' + today + '.xlsx',
          }),
        );
      } else {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: '다운로드할 데이터가 없습니다.',
          }),
        );
      }
    } else {
      if (statsUseList.length > 0) {
        dispatch(
          getSystemUseAggExcel({
            searchMenuInfo,
            excelFileName: '지점별로그인현황_' + today + '.xlsx',
          }),
        );
      } else {
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: '다운로드할 데이터가 없습니다.',
          }),
        );
      }
    }
  };

  //메뉴별 사용 통계현황
  const onPressEnter = () => {
      menuSearch();   //검색버튼 클릭
  }

  return (
    <React.Fragment>
      <Layout>
        <div className="content manage-content">
          <div className="con-wrap">
            <div className="app-wrap">
              <div className="app-box">
                <div className="tab-wrap">
                  {activeTab === 'menu' && <MenuTab tabClick={tabClick} />}
                  {activeTab === 'use' && <UseTab tabClick={tabClick} />}

                  <div className="tab-con active" id="con-tab1">
                    {activeTab === 'menu' && (
                      <MenuSearch
                        codeList={codeList}
                        hqList={hqList}
                        agencyList={agencyList}
                        handleCalculateDate={handleMenuCalculateDate}
                        monthHandler={monthHandler}
                        dayHandler={dayHandler}
                        weekHandler={weekHandler}
                        yearHandler={yearHandler}
                        handleAplctnDvcTyCd={handleAplctnDvcTyCd}
                        handleChangeOrgChnlCdSelect={
                          handleChangeOrgChnlCdMenuSelect
                        }
                        handleInputEvent={handleInputEvent}
                        searchInfo={searchMenuInfo}
                        onPressEnter={onPressEnter}
                        search={menuSearch}
                      />
                    )}
                    {activeTab === 'use' && (
                      <UseSearch
                        codeList={codeList}
                        hqList={hqList}
                        agencyList={agencyList}
                        handleCalculateDate={handleUseCalculateDate}
                        monthHandler={monthHandler}
                        dayHandler={dayHandler}
                        weekHandler={weekHandler}
                        yearHandler={yearHandler}
                        handleAplctnDvcTyCd={handleAplctnDvcTyCd}
                        handleChangeOrgChnlCdSelect={
                          handleChangeOrgChnlCdUseSelect
                        }
                        handleInputEvent={handleInputEvent}
                        searchInfo={searchUseInfo}
                        search={useSearch}
                      />
                    )}

                    {activeTab === 'menu' && (
                      <MenuList
                        initial={menuInitial}
                        menuColumns={menuColumns}
                        menuPageChange={menuPageChange}
                        menuList={statsMenuList}
                        statsMenuTotalCount={statsMenuTotalCount}
                        excelDown={excelDown}
                      />
                    )}
                    {activeTab === 'use' && (
                      <UseList
                        initial={useInitial}
                        useColumns={useColumns}
                        usePageChange={usePageChange}
                        useList={statsUseList}
                        statsUseTotalCount={statsUseTotalCount}
                        excelDown={excelDown}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default StatsMain;
